module.exports = __webpack_public_path__ + "static/img/idback.837979f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idback.png
// module id = MLw0
// module chunks = 1